


























































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
import { getDiamondRevenueExpensesList } from '@/api'
import moment from 'moment'
@Component({
  name: 'GoldenbeanHarvest',
  filters: {
    dateFormat: (value: any, pattern: any) => {
      return moment(value).format(pattern)
    }
  }
})
export default class GoldenbeanHarvest extends Vue {
  [x: string]: any
  list: any = []
  emptyImage = require('@/assets/Empty_NoData.png')

  created() {
    //获取钻石收支记录列表
    this.getDiamondRevenueExpensesList()
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  //获取钻石收支记录列表
  async getDiamondRevenueExpensesList() {
    const { data, code } = await getDiamondRevenueExpensesList()
    if (code == 1001) {
      this.list = data.list
    }
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  // 返回
  handelBack() {
    this.$router.back()
  }
}
